<div class="zona-carga">
  <app-upload-file-datos-documento
    [textoFondo]="textoDropzone"
    [accept]="'application/pdf'"
    [multiple]="true"
    [configDoc]="true"
    (fileListEmitter)="onFilesSelected($event)">
  </app-upload-file-datos-documento>

  <ng-container *ngIf="mostrarGenerico">
    <div class="zona-carga__separator">o bien:</div>

    <button type="button" class="zona-carga__generic-btn" (click)="abrirModalDocumentoGenerico()">
      <svg class="zona-carga__generic-icon"><use xlink:href="#hs-doc"></use></svg>
      Seleccione documento genérico
    </button>
  </ng-container>
</div>
